import React, { useState, useEffect } from "react";
import axios from "axios";
import MovieCard from "./MovieCard.js";

const Genre = () => {
  const [genres, setGenres] = useState([]);
  const [genre, setGenre] = useState([]);
  const [activeButton, setActiveButton] = useState(28);

  useEffect(() => {
    axios
      .get(
        "https://api.themoviedb.org/3//genre/movie/list?api_key=864351c4983b669ad95578b475142944&language=en-US&page=1"
      )
      .then((res) => {
        const modifiedData = res.data.genres.map((genre) => ({
          id: genre.id,
          name: genre.name,
        }));
        setGenres(modifiedData);
        console.log(res.data);
        handleGenreClick(28);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleGenreClick = async (genre_id) => {
    axios
      .get(
        `https://api.themoviedb.org/3/discover/movie?api_key=864351c4983b669ad95578b475142944&language=en-US&page=1&with_genres=${genre_id}`
      )
      .then((res) => {
        setGenre(res.data.results);
        console.log(res.data);
        setActiveButton(genre_id);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setButtonStyle = (genre_id) => {
    if (activeButton === genre_id) {
      return "active";
    }
  };

  return (
    <div>
      <div id="genre-buttons">
        {genres.name != "Documentary" ? genres.map((genre) => 
        genre.name === "Documentary"  ? (
          ""
          ) : (
          <button
            href="/Genre"
            key={genre.id}
            className={`genre-button ${setButtonStyle(genre.id)}`}
            onClick={() => {
              handleGenreClick(genre.id);
            }}
          >
            {genre.name}
          </button>
        )): ""}
      </div>
      <div className="row row-cols-1  row-cols-sm-2 row-cols-md-3 row-cols-lg-4 NewRel ">
        {genre.map((movie) => (
          <MovieCard movie={movie} />
        ))}
      </div>
    </div>
  );
};

export default Genre;